import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';

function DetailViewHeader({ title, icon, actions }) {
  return (
    <Styled.DetailViewHeaderWrapper>
      <Styled.DetailViewHeaderTop>
        <Styled.DetailViewHeaderIconColumn>
          {icon}
        </Styled.DetailViewHeaderIconColumn>
        <Styled.DetailViewNameColumn>
          <Styled.DetailViewHeaderName>{title}</Styled.DetailViewHeaderName>
          <Styled.DetailViewHeaderActionRow>
            {actions}
          </Styled.DetailViewHeaderActionRow>
        </Styled.DetailViewNameColumn>
      </Styled.DetailViewHeaderTop>
    </Styled.DetailViewHeaderWrapper>
  );
}

DetailViewHeader.propTypes = {
  /** Detail view title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  /** Slot for displaying an icon */
  icon: PropTypes.node.isRequired,
  /** Slot for displaying action buttons */
  actions: PropTypes.node,
};

DetailViewHeader.defaultProps = {
  actions: null,
};

export default DetailViewHeader;
